import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import VxConsultLogo from './VxConsultLogo';

const ProgramacaoHavanVxServiceUnavailableModal = ({
  show,
  row,
  message,
  loading,
  onClose,
  onRetry
}) => (
  <Modal show={show} onHide={onClose} centered>
    <Modal.Header closeButton={!loading}>
      <HeaderContent>
        <HeaderTitle>
          <HeaderAlertDot />
          <span>Serviço indisponível</span>
        </HeaderTitle>
        <VxConsultLogo size="sm" />
      </HeaderContent>
    </Modal.Header>
    <Modal.Body>
      <ErrorAccent />

      <LogoStage>
        <VxConsultLogo size="lg" />
      </LogoStage>

      <ErrorIcon aria-hidden="true">!</ErrorIcon>

      <ErrorTitle>Serviço VX fora do ar</ErrorTitle>
      <ErrorMessage>
        {message || 'A VX Consult está temporariamente indisponível. Tente novamente em alguns instantes.'}
      </ErrorMessage>

      <ContextBox>
        <ContextItem>
          <ContextLabel>CPF</ContextLabel>
          <ContextValue>{row?.cpf || '-'}</ContextValue>
        </ContextItem>
        <ContextItem>
          <ContextLabel>Placas</ContextLabel>
          <ContextValue>{(row?.placas || []).join(', ') || '-'}</ContextValue>
        </ContextItem>
      </ContextBox>
    </Modal.Body>
    <Modal.Footer>
      <ButtonWithLoading variant="outline-secondary" type="button" onClick={onClose} disabled={loading}>
        Fechar
      </ButtonWithLoading>
      <ButtonWithLoading variant="primary" type="button" onClick={onRetry} loading={loading} loadingText="Tentando...">
        Tentar novamente
      </ButtonWithLoading>
    </Modal.Footer>
  </Modal>
);

ProgramacaoHavanVxServiceUnavailableModal.propTypes = {
  show: PropTypes.bool,
  row: PropTypes.shape(),
  message: PropTypes.string,
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired
};

ProgramacaoHavanVxServiceUnavailableModal.defaultProps = {
  show: false,
  row: null,
  message: '',
  loading: false
};

export default ProgramacaoHavanVxServiceUnavailableModal;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  padding-right: 16px;
  color: #163455;
  font-weight: 700;
`;

const HeaderTitle = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const HeaderAlertDot = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #dc3545;
  box-shadow: 0 0 0 4px rgba(220, 53, 69, 0.12);
`;

const ErrorAccent = styled.div`
  height: 4px;
  margin: -16px -16px 18px;
  background: #dc3545;
`;

const LogoStage = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
`;

const ErrorIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin: 0 auto 12px;
  border: 2px solid #dc3545;
  border-radius: 50%;
  background: #fff1f1;
  color: #dc3545;
  font-size: 26px;
  font-weight: 800;
  line-height: 1;
`;

const ErrorTitle = styled.div`
  color: #b4232c;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
`;

const ErrorMessage = styled.div`
  max-width: 420px;
  margin: 8px auto 18px;
  color: #5f6b7a;
  font-size: 14px;
  line-height: 1.45;
  text-align: center;
`;

const ContextBox = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding: 12px;
  border: 1px solid #e3e9f0;
  border-radius: 4px;
  background: #f8fafc;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const ContextItem = styled.div`
  min-width: 0;
`;

const ContextLabel = styled.div`
  margin-bottom: 4px;
  color: #6c757d;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
`;

const ContextValue = styled.div`
  color: #24344d;
  font-size: 13px;
  font-weight: 600;
  word-break: break-word;
`;
